import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate } from "@/lib/plant";
import { Sprout, Leaf, Flower2, Apple, Scissors, Bean, Lock, Trophy } from "lucide-react";

const ICONS = {
  germinated: Bean,
  true_leaves: Sprout,
  vegetative: Leaf,
  first_flower: Flower2,
  first_fruit: Apple,
  first_harvest: Scissors,
};

export function MilestoneBadges({ plantId, refreshKey }) {
  const [milestones, setMilestones] = useState([]);

  useEffect(() => {
    api.get(`/plants/${plantId}/milestones`).then(({ data }) => setMilestones(data.milestones)).catch(() => setMilestones([]));
  }, [plantId, refreshKey]);

  if (!milestones.length) return null;
  const achievedCount = milestones.filter((m) => m.achieved).length;

  return (
    <div className="bg-card rounded-2xl border border-border p-5 sm:p-6 shadow-sm" data-testid="milestone-badges">
      <h2 className="font-display text-lg font-semibold mb-4 flex items-center gap-2">
        <Trophy className="h-5 w-5 text-amber-500" /> Growth Milestones
        <span className="text-sm font-normal text-muted-foreground">({achievedCount}/{milestones.length})</span>
      </h2>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
        {milestones.map((m) => {
          const Icon = ICONS[m.key] || Sprout;
          return (
            <div key={m.key} className="flex flex-col items-center text-center gap-1.5" data-testid={`milestone-${m.key}`}>
              <div
                className={`h-14 w-14 rounded-2xl flex items-center justify-center relative transition ${
                  m.achieved
                    ? "bg-gradient-to-br from-emerald-500 to-emerald-700 text-white shadow-sm"
                    : "bg-secondary text-muted-foreground"
                }`}
              >
                {m.achieved ? <Icon className="h-6 w-6" /> : <Lock className="h-5 w-5" />}
              </div>
              <span className={`text-xs font-medium leading-tight ${m.achieved ? "text-foreground" : "text-muted-foreground"}`}>{m.label}</span>
              {m.achieved && m.date && <span className="text-[10px] text-muted-foreground">{formatDate(m.date)}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
